const translationEn = {
   home: "Home",
   about_us: "About Us",
   services: "Services",
   air_freight: "Air",
   land_freight: "Land",
   sea_freight: "Sea",
   prices: "Prices",
   contact: "Contact",
   log_in: "Log In",
   sign_up: "Sign Up",
   welcome: "Welcome",
   password_email_incorrect: "Password or email incorrect !",
   transportation_in_any_direction: "Transportation in any direction",
   logistics_is_simple_with_us: "Logistics is simple with us",
   email_address: "Email address",
   password: "Password",
   forgot_password: "Forgot password ?",
   recover_here: "Recover here",
   enter: "Enter",
   not_register_yet: "Not register yet ?",
   passwords_dont_match: "Passwords do not match!",
   fill_all_fields: "Fill all fields !",
   agree_terms: "For registratio fill all fields !",
   email_or_already_registerd: "Email invalid or user is already registered !",
   physical_person: "Physical person",
   legal_entity: "Legal entity",
   name: "Name",
   name_eng: "Name Eng",
   personal_id: "Personal id",
   company_id: "Company ID",
   repeat_password: "Repeat password",
   surname: "Surname",
   surname_eng: "Surname Eng",
   company_name: "Company Name",
   company_name_eng: "Company Name Eng",
   phone: "Phone",
   password_eight_character: "(8 characters or more)",
   agree_to_our: "Agree to our ",
   terms_of_use: "terms of use",
   and: "and",
   privacy_policy: "privacy policy",
   already_have_an_account: "Already have an account?",
   send: "Send",
   got_questions_or_need_more_information:
      "Got questions or need more information?",
   fill_in_your_information_and_we_will_get_back_to_you:
      "Fill in your information and we will get back to you",
   error_msg: "Something went wrong!",
   footer_text: `MGL Parcel is a new parcel delivery service of MGL Group, which is a Bulgarian-Georgian company and has been operating in the Georgian market since 2012.
    We offer delivery of parcels from China, the USA and Greece.`,
   frequently_asked_questions: "Frequently asked questions",
   balance: "Balance",
   my_balance: "My Balance",
   balance_top_up: "Balance Top Up",
   bonus_points: "Bonus Points",
   parcels: "Parcels",
   my_parcels: "My Parcels",
   courier_service: "Courier Service",
   courier: "courier",
   addresses: "Addresses",
   my_addresses: "My Addresses",
   pick_country_for_address: "Pick a country to see its warehouse address",
   back_to_countries: "Back",
   no_office_in_country: "No warehouse in this country yet",
   home_delivery_prices: "Home-delivery pricing",
   prices_in_gel: "Prices in GEL (₾)",
   included_up_to_kg: "Delivery is free up to 10 kg",
   weight: "Weight",
   tbilisi_and_regions: "Tbilisi / Regions",
   highland: "Highland",
   region: "Region",
   admin_bracket_delivery_region_gel: "Delivery region",
   home_delivery_only_notice: "Parcels from this country ship directly to your address — no office pickup",
   see_delivery_prices: "See pricing",
   price_per_kg: "Price",
   other_cities_use_tbilisi_rate:
     "Any other city uses the Tbilisi / regions rate.",
   free_delivery_up_to_10kg:
     "Home delivery is free for parcels up to 10 kg",
   admin_home_delivery_only: "Home delivery only",
   admin_home_delivery_hint:
     "When on, parcels from this warehouse ship directly to the customer's address (no office pickup). Transport is quoted in the warehouse currency ({{symbol}}) — live {{code}}→GEL conversion at billing time.",
   admin_delivery_tariff_table: "Home-delivery tariff",
   admin_delivery_tariff_hint:
     "Each row is one weight range. Transport is charged per kg in the warehouse currency; delivery (₾) is added on top for the destination zone (Tbilisi / Highland).",
   admin_bracket_range: "Weight (kg)",
   admin_bracket_transport_short: "Transport",
   admin_bracket_transport_tbilisi: "Transport Tbilisi",
   admin_bracket_transport_highland: "Transport Highland",
   admin_bracket_delivery_tbilisi_gel: "Delivery Tbilisi",
   admin_bracket_delivery_highland_gel: "Delivery Highland",
   admin_no_brackets_yet: "Empty tariff — add a row below",
   admin_add_row: "Add row",
   transport_per_kg: "Transport",
   admin_onway: "OnWay Dispatch",
   flights: "Flights",

   home_delivery_notice_greeting: "Dear customer,",
   home_delivery_notice_p1:
     "By popular request, MGL Parcel is upgrading its service to make receiving parcels even easier and more comfortable.",
   home_delivery_notice_p2:
     "From September 1, 2026, your parcels will be delivered directly to the address you specify instead of the office.",
   home_delivery_notice_p3:
     "Please add your address in your personal cabinet in advance so your parcels arrive smoothly.",
   home_delivery_notice_bonus:
     "Based on customer feedback, delivery of parcels up to 10 kg to any city in Georgia is already included in the transportation fee — no extra charge.",
   home_delivery_notice_thanks: "Thank you for choosing MGL Parcel!",
   // legacy keys
   home_delivery_popup_title: "Coming soon — home delivery 🏠",
   home_delivery_popup_intro:
     "By popular request, we're changing how deliveries work — instead of picking parcels up from our office, we'll bring them directly to the address you set.",
   home_delivery_popup_action:
     "To get ready for the switch, please add your delivery address(es) in your profile.",
   add_my_address_now: "Add address",
   remind_later: "Remind me later",
   home_delivery_help:
     "Add the address(es) where you'd like to receive your parcels. We'll use these once home delivery goes live.",
   home_delivery_hint:
     "For the upcoming home-delivery service — please provide your address",
   no_addresses_yet: "No addresses added yet",
   add_new_address: "Add new address",
   new_address: "New address",
   city: "City",
   address: "Address",
   phone_optional: "Phone (optional)",
   account_phone: "account phone",
   set_as_default: "Set as default",
   already_default: "Default",
   default: "Default",
   default_updated: "Default updated",
   edit: "Edit",
   save: "Save",
   cancel: "Cancel",
   delete: "Delete",
   confirm_delete_address: "Delete this address?",
   something_went_wrong: "Something went wrong",
   reports: "Reports",
   transaction_history: "Transaction History",
   insurance: "Insurance",
   settings: "Settings",
   support: "Support",
   messages: "Messages",
   terms_agreement: " Terms & Agreement User policy",
   save_changes: "Save changes",
   change: "Change",
   changed: "Changed",
   go_back: "Go Back",
   new_password: "New password",
   repeat_new_password: "Confirm new password",
   new_email: "New email",
   email_changed: "Your email was changed",
   new_phone: "New phone",
   message: "Message",
   see_more: "See more",
   my_messages: "My messages",
   received_messages: "Received Messages",
   create_new_messages: "Create a new message",
   type_word_here: "Type the word here...",
   message_details: "Messege Details",
   subject: "Subject",
   assistance: "Assistance",
   transaction_history: "Transaction history",
   date: "Date",
   amount: "Amount",
   status: "Status",
   bank: "Bank",
   all_fights: "All Flights",
   land: "Land",
   air: "Air",
   sea: "Sea",
   select_country: "Select a Country",
   tatus: "Status",
   flight_number: "Shipment Number",
   estimated_arrival_date: "Estimated Arrival Date",
   arrival_date: "Arrival Date",
   address: "Address",
   town_city: "Town / City",
   state_province: "State / Province",
   country: "Country",
   post_code: "Post code (ZIP)",
   tracking_number: "Tracking Number",
   received: "Received",
   sent: "Sent",
   arrived: "Arrived",
   takeout: "Takeout",
   weight: " Weight",
   price: "Price",
   pay: "Pay",
   paid: "Paid",
   details: "Details",
   declare: "Declare",
   shipment: "Shipment",
   declaration_details: "Declaration Details",
   deliver_address: "Delivery Address",
   security: "Security",
   description: "Parcel description",
   website: "Web Page",
   currency: "Currency",
   upload_invoice: "Upload Invoice",
   addon_security: "Addon Security",
   save: "Save",
   invoice_details: "Invoice details",
   user_information: "User information",
   transportation_details: "Transportation details",
   transportation_price: "Transportation price",
   insurance_price: "Insurance price",
   total_value: "Total value",
   bank_information: "Bank information",
   account: "Account",
   type_amount_here: " Type Amount Here",
   choose_method: "Please choose desired payment method",
   payment: "Payment",
   amount: "Amount",
   top_up_my_ballance: "Top up my balance",
   view_bonus_points: "View Bonus Points",
   action: "Action",
   charging_amount_from_ballance: "Charging Amount from Balance",
   kg: "KG",
   g: "G",
   pay_with_points: "Pay with points",
   warehouse: "Warehouse",
   trustee: "Trustee",
   office: "Office",
   trcaution: `The authorized person can receive the parcel both at the courier address and at the specified office.`,
   transportation: "Transportation",
   about_us_banner_text: `Experience seamless parcel logistics with MGL PARCEL! For over a decade, we have been dedicated to providing reliable transportation services for your parcels originating from China, the USA and Greece.`,
   about_us_banner_quote: "Parcels are simple with us.",
   learn_more_about_us: "Learn More About Us",
   ten_year_eperiance: "10 YEARS OF EXPERIENCE",
   useful_information: "Useful Information",
   customs_regulations: "Customs regulations",
   client: "Client",
   street: "Street",
   terms_and_conditions: "Terms and conditions",
   minimum_package_weight: "Minimum package weight",
   track_parcels: "Track your package here",
   track_parcels_quote:
      "Find out the status of the package according to its tracking number",
   parcel_status: "Parcel status - ",
   data_not_found: "Data not found",
   send_new_password: "Send new password",
   password_sent: "Password sent on email!",
   email_invalid: "Email is not registered!",
   do_not_have_insuranced: "You do not have an insured package",
   only_georgian: "Write text only Georgian",
   unclear_parcels: "Unclear Parcels",
   unlcear_parcels_page_txt:
      "Find your package and send a message with the appropriate photo material.",
   sent_at: "Sent Date",
   terminals_at:
      "Date of commencement of terminal proceedings (needs 2-3 working days)",
   customs_at:
      "Date of initiation of customs procedures (needs 2-3 working days)",
   redistribution_at: "Distribution date to branches (needs 2-3 working days)",
   last_updated: "Last updated",
   pay_all: "Pay All",

   inner_about_us1: `Discover MGL Parcel - your trusted logistics partner with extensive experience and a strong presence across Europe, Georgia, and China. With a network of offices and warehouses strategically located in key locations, we offer seamless transportation services for your parcels, ensuring reliable and efficient delivery.`,
   inner_about_us2: `At MGL Parcel, we specialize in handling shipments from Turkey and China, providing you with a hassle-free solution to transport your parcels. Our expertise and established relationships enable us to navigate the complexities of international logistics, ensuring your packages reach their destinations safely and on time.`,
   inner_about_us3: `With a customer-centric approach, we prioritize your satisfaction by offering tailored solutions to meet your specific requirements. Whether you're an individual sending personal packages or a business requiring comprehensive logistics support, we have the capabilities and resources to fulfill your needs.`,
   inner_about_us4: `Experience the convenience and peace of mind that comes with partnering with MGL Parcel. Let us handle the transportation of your parcels from China, the USA and Greece, while you focus on your core business. Trust us to deliver your goods with care, efficiency, and expertise. Contact us today to learn more about our services and how we can assist you in your logistics needs.`,

   our_services: "Our Service",
   land_transportation: "Land transportation",
   kg_constraint: "The minimum weight of the package is 100 grams",
   land_serv1: "Italy – 3  EUR 1 KG /  100 EUR - 1 CBM",
   land_serv2: "",
   land_serv3: "China – 5 USD -1 KG",
   air_transportation: "Air transportation",
   air_serv1: "China – from 8 USD – 1 KG",
   air_serv2: "Special Offer for  cargo  over 45 KG",
   sea_transportation: "Sea transportation",
   sea_serv1: "China – 3.5 USD ",

   customs_rules_and_laws: "Customs rules and laws",
   customs_rules_and_laws_text:
      "As of May 14, 2022, Resolution No. 201 of the Government of Georgia was changed. According to the latest amendment, the Government of Georgia imposes a customs service tax on the goods to be cleared, along with the customs clearance amount.",
   customs_rules_and_laws_text1:
      "• 20 GEL will be added to the customs clearance amount for goods worth from 300 to 3,000 GEL;",
   customs_rules_and_laws_text2:
      "• 100 GEL will be added to the customs clearance amount for goods worth 3,000 to 10,000 GEL;",
   customs_rules_and_laws_text3:
      "The said amount will be paid to the account of the Treasury of Georgia (see account: 707017021), before the declaration is printed and the customs clearance fee is paid.",
   customs_rules_and_laws1:
      "In what cases is the parcel subject to customs clearance?",
   customs_rules_and_laws1_text:
      "• According to the legislation of Georgia, goods worth more than 300 GEL, weighing more than 30 kg or uniform goods are subject to customs clearance.",
   customs_rules_and_laws1_text1:
      "• Customs duty is 18% of the total cost of products and transportation.",
   customs_rules_and_laws2: "Why should you declare the item before arrival?",
   customs_rules_and_laws2_text:
      "• If the parcel is not declared by the time of its arrival, it will be delayed at customs for 1 working week.",
   customs_rules_and_laws2_text1: `• If you do not declare the parcel within the mentioned period, the parcel will be automatically handed over to the state for further disposal.
    Note that if several parcels cross the border in the name of the customer, and only a part is undeclared, customs will stop the customer's declared parcels along with the undeclared parcels.
    After 1 week, according to the law, all parcels together are transferred to the state.`,
   customs_rules_and_laws3:
      "What documentation is required to clear the parcel?",
   customs_rules_and_laws3_text:
      "• In the event that the parcel is subject to customs clearance, the customer must upload an invoice or purchase order to our website containing the following information:",
   customs_rules_and_laws3_text1: "•  Recipient's name",
   customs_rules_and_laws3_text2: "•  Recipient's last name",
   customs_rules_and_laws3_text3: "•  Room number",
   customs_rules_and_laws3_text4: "•  Package contents",
   customs_rules_and_laws3_text5: "•  Total value of the package.",
   customs_rules_and_laws3_text6: `Note: (1) According to the new rules of the Revenue Service, fines are provided in case of wrongly indicated value by the recipient of the parcel in the declaration`,
   customs_rules_and_laws4:
      "According to the legislation of Georgia, it is prohibited to send the following items by mail:",
   customs_rules_and_laws4_text: "• real money, coins or banknotes;",
   customs_rules_and_laws4_text1:
      "• bank and credit cards and other securities;",
   customs_rules_and_laws4_text2: "• food products;",
   customs_rules_and_laws4_text3: "• Explosive substances;",
   customs_rules_and_laws4_text4: "• soil and seedlings with soil;",
   customs_rules_and_laws4_text5: "• pornographic products;",
   customs_rules_and_laws4_text6: "• live animals;",
   customs_rules_and_laws4_text7:
      "• any kind of drugs, products containing narcotic substances;",
   customs_rules_and_laws4_text8:
      "• Plants or their seeds containing narcotic or psychotropic substances;",
   customs_rules_and_laws4_text9: "• psychotropic substances;",
   customs_rules_and_laws4_text10: "• Medicines (more than 10 packs);",
   customs_rules_and_laws4_text11: "• seeds of plants (more than 25 grams);",
   customs_rules_and_laws5:
      "List of prohibited items by country and destination:",
   customs_rules_and_laws5_text: "",
   customs_rules_and_laws5_text1: `• China Air - Gun, target, gun parts, etc., magnet, candle, lighter (including electric lighter), powder, pressed powder, toothpaste, eye shadow, knife, scissors and similar sharp objects, toy gun, electronic cigarette , power bank, battery, liquids, paint, felt-tip pen, plants, 
    Cargo for medical purposes, items (it is allowed to bring an item only if it comes with the item, for example - a mobile phone) and cosmetics such as: manicure, acetone, creams and others. Products with explosive and flammable packaging. Among them: spray, pulverizer, deodorizer, aerosol and perfume.`,
   customs_rules_and_laws5_text2:
      "• China Marine - plants, products with explosive and flammable packaging. Weapons, targets, weapon parts, etc.",

   panel_insurance_text:
      "MGL PARCEL offers its customers to insure parcels before sending them to Georgia. and thereby provide full compensation for loss in case of loss of the parcel or damage to it during transportation.",
   panel_insurance_text1:
      "The registered parcel can be insured after receiving it before sending the parcel to Georgia. 10% of the value of the package will be added to the cost of transportation in case of insurance.",

   თურქეთი: "Turkey",
   ჩინეთი: "China",

   code_sent: "Code sent to email",
   email_registerd_or_error:
      "The specified email is already registered or another error has occurred. Please try again.",
   invalid_code_or_error:
      "The specified code is invalid or another type of error has occurred. Please try again.",
   email_valid_procc:
      "Please go through the email validation process before continuing",
   required: "Required",

   not_started: "Not Started",
   sent: "Sent",
   arrived: "Arrived",
   attach_file: "Attach File",
   attached_file: "Attached File",
   denied_items: "Denied Items",

   georgian: "GEO",
   personal_parcel: "Personal Parcel",
   parcel_amount: "Item Amount",
   trusted_person: "Trusted Person",

   batumi_poti: "Batumi / Poti",
   working_hours: "Working hours",
   tbilisi: "Tbilisi",
   monday_friday: "Monday - Friday:",
   saturday: "Saturday:",

   repack: "Repack",
   repacked: "Repacked",

   calculate: "Calculate",
   vol_calculator: "Volumetric weight calculator",
   repack_err:
      "Unable to repack the package because the price of the package is calculated based on the actual weight",
   onlineShop: "Online Shop",

   declarationPrices: "Declaration",
   register: "register",
   instruction: "Instructions",
   calculator: "calculator",
   information: "information",
   logout: "logout",

   quotePartOne: "The most reliable way to",
   quotePartTwo: "order parcels",
   quotePartThree: "from",
   bannerTextOne: "Retail Direction",
   bannerTextTwo: "Corporate Direction",

   // Warehouse-country chips (FirstSection + BannerSection).
   our_international_warehouses: "Our international warehouses — where you shop",
   warehouse_modes_china: "Air, sea and land shipping",
   warehouse_modes_usa: "Air shipping",
   warehouse_modes_greece: "Land shipping",
   delivery_zone: "Delivery zone",
   what_is_highland: "What is Highland?",
   current_price: "Current",
   from_date_label: "from",

   // Promocode (Settings page + admin display)
   promo_code: "Promocode",
   promo_one_at_a_time: "Only one promocode can be active at a time.",
   promo_active: "active",
   promo_inactive: "expired",
   promo_from: "from",
   promo_to: "to",
   promo_none: "You don't have an active promocode.",
   promo_replace_hint: "New promocode (replaces the current one)",
   promo_enter_hint: "Enter a promocode",
   promo_placeholder: "e.g. SUMMER25",
   promo_apply: "Activate",
   promo_remove: "Remove",
   promo_applied: "Promocode activated",
   promo_removed: "Promocode removed",
   promo_not_found: "Promocode not found",
   promo_expired: "Promocode has expired",
   promo_apply_error: "Error — please try again",
   admin_current_promo: "Active promocode",
   admin_scheduled_pricing: "Scheduled tariff change",
   admin_scheduled_pricing_hint:
     "From this date, PriceCalculator uses the flat price below instead of the tier table. Highland is billed separately per user address.",
   admin_scheduled_from: "Effective from",
   admin_price_scheduled_tbilisi: "Tbilisi / regions",
   admin_price_scheduled_highland: "Highland",

   // MGL Parcel (B2C) block.
   mgl_parcel_tag: "B2C service",
   mgl_parcel_headline:
     "MGL Parcel — the easy way to shop internationally.",
   mgl_parcel_body_intro:
     "Order what you want from online stores in China, the US and Greece, and use MGL Parcel's international warehouses to receive your packages.",
   mgl_parcel_body_we_handle:
     "We handle the rest — from receiving your parcel abroad to bringing it to Georgia and delivering it to your address.",
   mgl_parcel_schedule_heading:
     "Scheduled shipments. Predictable delivery.",
   mgl_parcel_schedule_body:
     "MGL Parcel's shipments run on a set schedule, so online shopping stays simple and predictable.",
   mgl_parcel_10kg_free:
     "Nationwide door-to-door delivery for parcels up to 10 kg is already included in the transport tariff.",
   mgl_parcel_10kg_over:
     "For parcels heavier than 10 kg you pay only the courier surcharge for the weight above 10 kg.",
   mgl_parcel_punchline: "One service. Three countries. All of Georgia.",
   mgl_parcel_punchline_body:
     "MGL Parcel brings together international warehouses, multiple shipping modes, scheduled flights and last-mile delivery in a single simple system.",
   mgl_parcel_cta:
     "Order from any online store in the world. Receive it in Georgia!",

   // MGL Group (B2B) block.
   mgl_group_tag: "B2B logistics service",
   mgl_group_headline:
     "MGL Group — a Bulgarian-Georgian international logistics partner for business.",
   mgl_group_body_p1:
     "International trade is a connected system of suppliers, warehouses, ports, transport routes, customs and end markets.",
   mgl_group_body_p2:
     "MGL Group builds that system into a single logistics chain.",
   mgl_group_body_p3:
     "We combine international shipping, warehousing, cargo consolidation, customs services, port operations and distribution so that business gets not just transportation but a planned, controlled logistics solution.",
   mgl_group_network_heading:
     "Network: Asia — Europe — Caucasus — Central Asia",
   mgl_group_network_body:
     "Our infrastructure includes strategic logistics routes and warehouses, including China and Europe. Through Georgia we build efficient links to regional markets.",
   mgl_group_reach_heading:
     "Businesses we serve:",
   mgl_group_reach_body:
     "Georgia, Armenia, Azerbaijan, Kazakhstan, Uzbekistan, Central Asia, Europe.",
   mgl_group_poti_heading: "Poti port",
   mgl_group_poti_body:
     "From receiving sea cargo through port operations, customs and onward transport — we manage the connected stages of cargo movement. From the port to any point in Georgia and beyond to regional markets by road and rail.",
   mgl_group_modes_heading:
     "Sea · Land · Air · Rail · Multimodal",
   mgl_group_modes_body:
     "Based on cargo type, volume, deadline, destination and commercial goal, we build the right transport model and choose the route that's optimal for your business.",
   mgl_group_punchline:
     "MGL Group — one partner for the whole logistics chain.",
   yearsWithYou: "year with you",
   flight: "Flight",
   volume: "Volume",
   workingDay: "working day",
   calculatorsTitle: "Definition of volumetric weight",
   calculatorsTextOne: `Volumetric weight is a special unit of measurement that is used
  To determine the density of a specific item. This measurement is important for international aviation
  During the execution of shipments. The formula for calculating volumetric weight is: length
  (cm) x width (cm) x height (cm) /6000 = volumetric weight (kg).`,
   instructionsTitle: "How to subscribe?",
   instructionsText: `We offer you video instructions on how to subscribe
  from Chinese online stores and how to add our shipping address,
   on various trading platforms. Also how to declare by us
   registered parcel`,
   seeAll: "see all",
   instructions: "Instructions",
   noInstructions: "instructions not found",
   logout: "log out",
   height: "height",
   width: "width",
   length: "length",
   giftText: "For every 10 kilograms, 1 kilogram as a gift !",
   easy: "easily",
   reliable: "reliably",
   codes: "codes",
   else: "else",
   empty: "No records found !",
   registration_successful: "Registration Successful",
   userCabinet: "user cabinet",
   fast: "fast",
   china: "China",
   usa: "USA",
   greece: "Greece",
   turkey: "Turkey",
   uploadInvoice: "Invoice Required",
   airPrice: "from 10$",

   more_than_250: "The price of the package exceeds 250 GEL",
   more_than_30: "The weight of the package exceeds 30 kilos",
   more_than_4: "The amount of items is greater than 4",

   blogs: "Blogs",
   blogs_not_found: "Blogs not found",

   real_weight: "Real",
   volume_weight: "Volumetric",
   promoCode: "Promo code",
   checkPromoCode: "Check promo code",
   promoCodeDoNotExits: "This promo code does not exist",
   rateUs: "Rate us",
   leaveReview: "Leave a review",
   incident_lost: "Parcel lost",
   incident_damaged: "Parcel damaged",
   incident_no_transport: "You are not charged for transport.",
   incident_refunded_balance: "The {{amount}} ₾ you paid was returned to your balance.",
   incident_refunded_points: "The {{amount}} points you paid were returned.",
   incident_compensated: "The item value — {{amount}} ₾ — was credited to your balance.",
   rate_intro: "One minute — your rating helps us get better.",
   rate_choose_score: "Pick a star rating",
   rate_comment_optional: "Comment (optional)",
   rate_send: "Send",
   rate_score_1: "Poor",
   rate_score_2: "Weak",
   rate_score_3: "Okay",
   rate_score_4: "Good",
   rate_score_5: "Excellent",
   rate_thank_you: "Thank you!",
   rate_thank_you_text: "Your rating has been received. Thank you for using MGL Parcel.",
   rate_redirect_in: "Taking you to the main page in {{n}}s…",
   go_to_main: "Go to main page",
   rate_already_used: "This link has already been used",
   rate_already_used_text: "You already left a rating with this link — thank you! You will get a new one when your next parcel is delivered.",
   rate_invalid_link: "This link is invalid or has expired",
   rate_invalid_link_text: "A rating link works for 30 days and can be used once. You will get a new one when your next parcel is delivered.",

   fine: "Fine",
   boughtWithPoints: "Paid with bonus points",
   "Volumetric weight from 80 cm": "Volumetric weight from 80 cm",
   "Volumetric weight from 50 cm": "Volumetric weight from 50 cm",
   border_declar_needs_declaration: "Red",
   border_declar_declared: "Green",
   border_declar_in_customs: "Yellow",
   border_declar_not_needed: "Red",

   // ===== Admin Panel Keys =====
   // Navigation
   admin_users: "Users",
   admin_admins: "Administrators",
   admin_countries: "Countries",
   admin_abroad_warehouse: "Abroad Warehouse",
   admin_filials: "Branches",
   admin_flights: "Flights",
   admin_faq: "FAQ",
   admin_archive: "Archive",
   admin_packages: "Packages",
   admin_warehouse_arrived: "In Warehouse",
   admin_sent: "Sent",
   admin_arrived: "Arrived",
   admin_delivered: "Delivered",
   admin_support: "Support",
   admin_messages: "Messages",
   admin_declaration_service: "Declaration Service",
   admin_exports: "Exports",
   admin_popup: "Popup",
   admin_blogs: "Blogs",
   admin_promo_codes: "Promo Codes",
   admin_reviews: "Reviews",

   // Login
   admin_welcome_back: "Welcome Back",
   admin_please_login: "Please login to continue",
   admin_email_placeholder: "Email",
   admin_password_placeholder: "Password",
   admin_login_button: "Login",
   admin_login_error: "Password or email is incorrect!",

   // Users page
   admin_user_search_placeholder: "User ID, email, phone",
   admin_physical: "Physical",
   admin_legal: "Legal",
   admin_online_shop: "Online Shop",
   admin_all: "All",
   admin_edit_user_info: "Edit User Information",
   admin_save: "Save",
   admin_login_as: "Login As",
   admin_first_name: "First Name",
   admin_last_name: "Last Name",
   admin_email: "Email",
   admin_personal_number: "Personal Number",
   admin_first_name_latin: "First Name (Latin)",
   admin_last_name_latin: "Last Name (Latin)",
   admin_phone: "Phone",
   admin_identification_code: "Identification Code",
   admin_balance: "Balance",
   admin_discount_percent: "Discount Percent",
   admin_type: "Type",
   admin_physical_person: "Physical Person",
   admin_legal_person: "Legal Person",
   admin_name_surname: "Name & Surname",
   admin_room_number: "Room Number",
   admin_edit: "Edit",

   // Common toast messages
   admin_success: "Operation completed successfully!",
   admin_error: "An error occurred, please try again!",
   admin_data_updated: "Data updated successfully!",
   admin_deleted_success: "Deleted successfully!",
   admin_added_success: "Added successfully!",
   admin_saved_success: "Saved successfully!",
   admin_sent_success: "Sent successfully!",
   admin_packages_sent: "Packages sent successfully!",
   admin_packages_received: "Packages received successfully!",
   admin_packages_delivered: "Packages delivered successfully!",
   admin_package_deleted: "Package deleted successfully!",
   admin_returned_to_prev: "Packages returned to previous section!",
   admin_action_success: "Action completed successfully!",

   // FAQ page
   admin_add_new_faq: "Add New FAQ",
   admin_categories: "Categories",
   admin_payments: "Payments",
   admin_general: "General",
   admin_customs_rules: "Customs Rules",
   admin_video_instruction: "Video Instruction",
   admin_branch_name: "Branch Name",
   admin_answer: "Answer",
   admin_edit_faq: "Edit FAQ",

   // Messages page
   admin_inbox: "Inbox",
   admin_sent_messages: "Sent",
   admin_send_global_message: "Send Global Message",
   admin_message: "Message",
   admin_send: "Send",
   admin_send_personal_message: "Send Personal Message",
   admin_number: "Number",
   admin_person: "Person",
   admin_subject: "Subject",
   admin_date: "Date",
   admin_attached_file: "Attached File",
   admin_attach_file: "Attach File",

   // Promo codes page
   admin_add_new_code: "Add New Code",
   admin_office: "Office",
   admin_code: "Code",
   admin_discount_percent_example: "Discount % (e.g.: 20)",
   admin_date_from: "Date From",
   admin_date_to: "Date To",
   admin_edit_code: "Edit Code",
   admin_name_or_discount_empty: "Name or discount percent is empty",

   // Support page
   admin_messages_label: "Messages",

   // Filials page
   admin_add_new_filial: "Add New Branch",
   admin_edit_filial: "Edit Branch",
   admin_filial_name: "Branch Name",
   admin_address: "Address",
   admin_city: "City",
   admin_working_hours: "Working Hours",
   admin_map_url: "Map URL",

   // Archive page
   admin_transactions: "Transactions",
   admin_logs: "Logs",
   admin_package_history: "Package History",
   admin_user: "User",
   admin_package_number: "Package Number",
   admin_action: "Action",
   admin_description: "Description",
   admin_user_room_id: "User Room ID",
   admin_transaction_code: "Transaction Code",
   admin_amount: "Amount",
   admin_status: "Status",
   admin_completed_success: "Completed Successfully",
   admin_completed_failure: "Failed",
   admin_admin: "Admin",

   // Admins page
   admin_add_new_admin: "Add New Admin",
   admin_admin_role: "Admin Role",
   admin_super_admin: "Super Admin",
   admin_turkey_operator: "Turkey Operator",
   admin_sea_china_operator: "Sea - China Operator",
   admin_air_china_operator: "Air - China Operator",
   admin_usa_operator: "USA Operator",
   admin_greece_operator: "Greece Operator",
   admin_ops_operator: "Operations (parcels + OnWay)",
   admin_edit_admin_profile: "Edit Admin Profile",
   admin_change: "Change",

   // Reviews page
   admin_rating: "Rating",

   // Popups page
   admin_add_new_popup: "Add New Popup",
   admin_text_georgian: "Text Georgian",
   admin_text_english: "Text English",
   admin_text_russian: "Text Russian",

   // Countries page
   admin_add_new_country: "Add New Country",
   admin_upload_photo: "Upload Photo",
   admin_country: "Country",
   admin_edit_country: "Edit Country",

   // Exports page
   admin_abroad_office: "Abroad Office",
   admin_flights_label: "Flights",
   admin_in_warehouse: "In Warehouse",
   admin_sent_status: "Sent",
   admin_arrived_status: "Arrived",
   admin_delivered_status: "Delivered",
   admin_georgia_offices: "Georgia Offices",
   admin_transportation: "Transportation",
   admin_flights_export_csv: "Flights Export CSV",
   admin_users_ledger: "Users — BOG deposits",
   admin_users_ledger_hint: "Every user and the total they deposited through BOG (with count and last deposit date).",
   admin_users_ledger_user: "User",
   admin_users_ledger_dates_note: "The date range applies to the deposits",
   admin_date_kind: "Date type",
   admin_date_received: "Received at abroad office",
   admin_date_sent: "Sent",
   admin_date_arrived: "Arrived in Georgia",
   admin_date_shown: "Shown to customer",
   admin_date_delivered: "Collected by customer",
   admin_date_paid: "Paid",
   admin_date_pick_range: "Pick a date (from / to)",
   admin_matches: "Matches",
   admin_declarant_export_csv: "Declarant Export CSV",

   // Flights page
   admin_add_new_flight: "Add New Flight",
   admin_search_keyword: "Search Keyword",
   admin_flight_type: "Type",
   admin_clear: "Clear",
   admin_arrival_approx_time: "Approximate Arrival Time",
   admin_flight_number: "Flight Number",
   admin_approx_arrival: "Approx. Arrival Time",
   admin_arrival_time: "Arrival Time",
   admin_turkey: "Turkey",
   admin_china: "China",
   admin_cargo: "Cargo",
   admin_airplane: "Airplane",
   admin_ship: "Ship",
   admin_not_started: "Not Started",
   admin_on_the_way: "On The Way",
   admin_has_arrived: "Has Arrived",
   admin_edit_flight: "Edit Flight",
   admin_start_date: "Start Date",
   admin_end_date: "End Date",

   // Blogs admin page
   admin_other: "Other",
   admin_main_info: "Main Info",
   admin_add_new_blog: "Add New Blog",
   admin_main_photo: "Main Photo",
   admin_inner_photos: "Inner Photos",
   admin_title: "Title",
   admin_short_description: "Short Description",
   admin_long_description: "Long Description",
   admin_close: "Close",
   admin_edit_info: "Edit Info",
   admin_edit_blog: "Edit Blog",

   // Abroad offices page
   admin_add_new_warehouse: "Add New Warehouse",
   admin_edit_warehouse: "Edit Warehouse",
   admin_warehouse: "Warehouse",
   admin_global_no_scope: "— global (all warehouses) —",
   admin_price: "Price",
   admin_phone_label: "Phone",
   admin_zip_code: "Zip Code",
   admin_state: "State",
   admin_address1: "Address 1",
   admin_address2: "Address 2",
   admin_country_label: "Country",
   admin_weight_price: "Weight Price",
   admin_office_type: "Office Type",

   // Declaration service page
   admin_room_number_label: "Room Number",
   admin_flight_label: "Flight",
   admin_amount_label: "Amount",
   admin_no_data_found: "No data found",
   admin_to_pay: "To Pay",
   admin_paid: "Paid",
   admin_delete: "Delete",

   // Package pages common
   admin_choose: "Choose",
   admin_search: "Search",
   admin_select_all: "Select All",
   admin_insured_packages: "Insured Packages",
   admin_repacked_packages: "Repacked Packages",
   admin_send_selected: "Send Selected",
   admin_send_by_flight: "Send By Flight",
   admin_receive_selected: "Receive Selected",
   admin_deliver_selected: "Deliver Selected",
   admin_show_to_user: "Show To User As Arrived",
   admin_export_csv: "EXPORT CSV",
   admin_flight_number_for_excel: "Flight number for Excel export",
   admin_general_flight_number: "General flight number (optional)",
   admin_warehouse_packages: "Warehouse Packages",
   admin_sent_packages: "Sent Packages",
   admin_arrived_packages: "Arrived Packages",
   admin_receivable_packages: "Receivable Packages",

   // Package item details
   admin_user_info: "User Information",
   admin_shipment_info: "Shipment Information",
   admin_tracking_number: "Tracking Number",
   admin_total_amount: "Total Amount",
   admin_total_weight: "Total Weight",
   admin_transport_type: "Transportation",
   admin_flight_info: "Flight",
   admin_trusted_person: "Trusted Person",
   admin_comment: "Comment",
   admin_repack_needed: "Repack Needed",
   admin_item_price: "Item Price",
   admin_transport_price: "Transport Price",
   admin_insurance: "Insurance",
   admin_invoice: "Invoice",
   admin_no: "No",
   admin_yes: "Yes",
   admin_details: "Details",
   admin_remove: "Remove",
   admin_back: "Back",
   admin_send_out: "Send",
   admin_receive: "Receive",
   admin_deliver: "Deliver",
   admin_memorize: "Save Changes",
   admin_delete_declaration: "Delete Declaration",
   admin_cancel_courier: "Cancel Courier",
   admin_remove_repack: "Remove Repack",
   admin_reset_fine: "Reset Fine",
   admin_assign_user: "Assign User",
   admin_weight: "Weight",
   admin_length: "Length",
   admin_width: "Width",
   admin_height: "Height",
   admin_flight_number_input: "Flight Number",
   admin_declar_not_needed: "Not Needed",
   admin_declar_red: "Red",
   admin_declar_green: "Green",
   admin_declar_yellow: "Yellow",
   admin_inner_courier_amount: "Inner Courier Amount",
   admin_language: "Language",
   admin_georgian: "Georgian",
   admin_english: "English",

   // FilialsCardWar
   admin_discount_percent_label: "Discount Percent",
   admin_inner_courier_price: "Inner Courier Price",

   // Additional toast/status keys used by agents
   admin_error_try_again: "An error occurred, please try again!",
   admin_added_successfully: "Added successfully!",
   admin_deleted_successfully: "Deleted successfully!",
   admin_data_updated_success: "Data updated successfully!",
   admin_data_updated_successfully: "Data updated successfully!",
   admin_data_added_success: "Added successfully!",
   admin_data_deleted_success: "Deleted successfully!",
   admin_blog_deleted_success: "Blog deleted successfully!",
   admin_blog_added_success: "Blog added successfully!",
   admin_blog_updated_success: "Blog updated successfully!",
   admin_updated_success: "Updated successfully!",
   admin_office_deleted_success: "Office deleted successfully!",
   admin_office_added_success: "Office added successfully!",
   admin_country_deleted_success: "Country deleted successfully!",
   admin_country_added_success: "Country added successfully!",
   admin_data_added_successfully: "Data added successfully!",

   // Additional field keys
   admin_search_placeholder: "User ID, email, phone",
   admin_region: "Region",
   admin_min_weight: "Minimum Weight",
   admin_currency: "Currency",
   admin_delivery_price: "Delivery Price",
   admin_repack_price: "Repack Price",
   admin_volumetric_min_side: "Volumetric weight — longest side from, cm (0 = any)",
   admin_prices: "Prices",
   admin_arrival_approx_date: "Approximate Arrival Date",
   admin_redistribution_start_date: "Branch Redistribution Start Date",
   admin_arrival_date: "Arrival Date",
   admin_sent_date: "Sent Date",
   admin_terminal_procedures_start_date: "Terminal Procedures Start Date",
   admin_customs_procedures_start_date: "Customs Procedures Start Date",

   // Additional package page keys
   admin_created_date: "Created Date",
   admin_fine: "Fine",
   admin_total_price: "Total Amount",
   admin_kg: "kg",
   admin_insured: "Insured",
   admin_not_insured: "Not Insured",
   admin_bag: "Bag",
   admin_volume_weight: "Volumetric Weight",
   admin_flight: "Flight",
   admin_nullify_fine: "Reset Fine",
   admin_border_declaration_status: "Border Declaration Status",
   admin_no_declaration_needed: "No Declaration Needed",
   admin_red: "Red",
   admin_green: "Green",
   admin_yellow: "Yellow",
   admin_creation_date: "Creation Date",
   admin_unpaid: "Unpaid",
   admin_courier_cancel: "Cancel Courier",
   admin_repack_remove: "Remove Repack",
   admin_fine_reset: "Reset Fine",
   admin_declaration_not_needed: "Not Needed",
   admin_package_delivered_success: "Package delivered successfully!",
   admin_package_fee_or_declaration_fee_unpaid: "Package fee is unpaid or declaration fee is pending!",
   admin_package_fee_unpaid: "Package fee is unpaid!",
   admin_unpaid_package_or_other_error: "Unpaid package or other error detected!",
   admin_package_deleted_success: "Package deleted successfully!",
   admin_shown_to_user_success: "Successfully shown to user!",
   admin_packages_returned_to_previous_section: "Packages returned to previous section!",
   admin_changed_success: "Changed successfully!",
   admin_georgia_branches: "Georgia Branches",

   // Additional blog/admin keys
   admin_blog_deleted_success: "Blog deleted successfully!",
   admin_blog_added_success: "Blog added successfully!",
   admin_blog_updated_success: "Blog updated successfully!",
   admin_updated_success: "Updated successfully!",
   admin_office_deleted_success: "Office deleted successfully!",
   admin_office_added_success: "Office added successfully!",
   admin_country_deleted_success: "Country deleted successfully!",
   admin_country_added_success: "Country added successfully!",
   admin_data_added_successfully: "Data added successfully!",
   admin_added_successfully: "Added successfully!",
   admin_deleted_successfully: "Deleted successfully!",
   admin_data_updated_successfully: "Data updated successfully!",
   admin_error_try_again: "An error occurred, please try again!",
   admin_data_added_success: "Added successfully!",
   admin_data_deleted_success: "Deleted successfully!",
   admin_data_updated_success: "Data updated successfully!",
   // Delivery address asked for at declaration time
   delivery_address: "Delivery address",
   add_new_address: "New address",
   choose_address: "Choose a delivery address",
   no_address_yet: "You have no address yet — add one to continue.",
   city: "City",
   address: "Address",
   phone: "Phone",
   optional: "optional",
   fill_all_fields: "City and address are required",
   send_code: "Send code",
   sms_code: "SMS code",
   verify_phone_first: "Verify your phone number first",
   verify_email_first: "Verify your email first",
   sms_code_sent: "Code sent by SMS",
   email_code: "Code from the email",
   confirm_code: "Confirm",
   // Price breakdown popup (user panel, admin panel, landing calculator)
   price_breakdown: "Price breakdown",
   why_this_price: "Why does it cost this?",
   how_price_calculated: "How this price was calculated",
   parcel_details: "Parcel details",
   flight_title: "Your parcels on this flight",
   flight_this: "this parcel",
   flight_total: "Flight total",
   flight_due: "Total due",
   flight_tier_note: "The per-kg rate was picked by the combined weight — {{total}} kg ({{tier}} kg tier), not by this parcel alone.",
   flight_home_note: "Each parcel is priced on its own weight; the courier fee is charged once, on the combined {{total}} kg.",
   flight_fee_estimate: "Estimated courier fee",
   flight_together: "They arrive together and go out in one delivery.",
   flight_split_address: "The parcels have different addresses — they will be delivered separately.",
   whats_going_on: "Where the parcel is",
   step_registered: "Registered",
   step_warehouse: "Received at warehouse",
   step_sent: "Sent",
   step_terminals: "At terminal",
   step_customs: "At customs",
   step_arrived: "Arrived in Georgia",
   step_arrived_est: "Estimated arrival",
   step_ready: "Ready for handover",
   step_courier: "Handed to courier",
   step_delivered: "Delivered",
   customs_title: "Customs",
   customs_not_needed: "No customs declaration needed",
   customs_must_declare: "Customs declaration required",
   customs_declared: "Cleared customs",
   customs_in_customs: "Held at customs",
   declaration_missing: "Parcel is not declared — add its value and items",
   declaration_ok: "Declaration filled in",
   delivery_title: "Delivery",
   delivery_by_courier: "A courier will bring it to your address and call you first",
   delivered_by_courier: "Delivered by courier",
   delivered_to_address: "Delivered to the address",
   delivered_to_person: "Handed to a trusted person",
   delivered_to_recipient: "Collected",
   delivery_group_note: "The courier fee is charged once per address, on the combined weight of all parcels — not per parcel.",
   delivery_fee_free: "Free",
   courier_order: "Courier order (OnWay)",
   courier_status: "Status",
   courier_cancelled: "Order cancelled",
   courier_expected: "Expected delivery",
   courier_cod: "To pay the courier",
   courier_history: "Courier history",
   courier_grouped_with: "In the same order:",
   payment_title: "Payment",
   payment_paid_full: "Paid",
   payment_due: "Due",
   paid_via_courier: "Paid to the courier",
   payment_cod_locked: "This parcel went to the courier with cash on delivery — pay on receipt; online payment is temporarily locked.",
   todo_title: "What you still need to do",
   todo_address: "Add a delivery address",
   todo_declaration: "Declare the parcel",
   todo_payment: "Pay the outstanding amount",
   todo_pay_at_door: "Pay the courier on receipt",
   todo_none: "All set — nothing else needed",
   billed_weight: "Billed weight",
   billed_on_volume: "by volumetric weight",
   billed_on_real: "by real weight",
   price_per_kg: "Price per kg",
   volume_formula: "Volumetric weight = length × width × height (m) × 167",
   volume_not_used_small: "Volumetric weight does not apply — no side of the parcel exceeds {{cm}} cm (longest: {{longest}} cm).",
   volume_not_used_repack: "The parcel was repacked into our box, so it is billed on its real weight.",
   volume_not_used_nodim: "The parcel was not measured, so it is billed on its real weight.",
   volume_used_note: "Volumetric weight is greater than the real weight, so the price is based on it.",
   tier_note: "The per-kg rate ({{tier}} kg) was picked from the combined weight of all your parcels on this flight — {{group}} kg.",
   tier_note_single: "The per-kg rate was picked from the {{tier}} kg band.",
   bracket_note: "The rate was picked from the {{bracket}} kg band.",
   scheduled_rate_note: "This warehouse's updated tariff is in effect.",
   zone_highland: "Highland zone",
   zone_tbilisi: "Tbilisi / regions",
   line_base: "Transportation",
   line_repack_uplift: "Repacking",
   line_delivery_overage: "Courier service",
   line_insurance: "Insurance (10%)",
   line_discount: "Discount",
   line_promo: "Promo code",
   line_inner_price: "Inner shipping",
   line_fine_price: "Fine",
   total_to_pay: "Total",
   price_locked_note: "An administrator has fixed the price of this parcel.",
   price_stale_note: "The amount due is {{charged}} ₾. At current tariffs the same parcel would cost {{computed}} ₾.",
   rate_used: "Rate",
   explain_load_error: "Could not load the breakdown.",
   // Landing-page shop directory
   shops: "Shops",
   shops_subtitle: "Pick a shop, order your item, and we bring it to you",
   all_countries: "All countries",
   all_categories: "All categories",
   no_shops_found: "No shops match this filter",
   // Admin shop directory
   admin_shops: "Shops",
   admin_shop_categories: "Shop categories",
   admin_shop_category_delete_note: "Deleting a category keeps its shops — they simply lose the category.",
   admin_link: "Link",
   admin_logo: "Logo",
   admin_category: "Category",
   admin_sort: "Sort",
   admin_active: "Active",
   admin_name_ge: "Name (GE)",
   admin_name_en: "Name (EN)",
   admin_fill_required: "Fill in the required fields",
   admin_name: "Name",
   admin_cancel: "Cancel",
   admin_add: "Add",
   admin_add_new: "Add new",
   admin_something_wrong: "Something went wrong",
   cm: "cm",
   // Courier delivery fee (one per address)
   delivery_fee: "Courier service",
   delivered_by_courier_on: "Delivered by courier on",
   delivery_fee_past: "Previous delivery — courier fee",
   delivery_fee_note: "Charged once for all parcels going to this address. If another parcel joins, the fee updates and you only pay the difference.",
   no_delivery_address_yet: "No delivery address set yet",
   total_weight_short: "Total weight",
   already_paid: "Already paid",
   payment_success: "Payment completed",
   not_enough_funds: "Not enough funds on your balance",
   nothing_to_pay_here: "Nothing to pay on the site — anything left is paid to the courier",
   pay_at_courier: "You will pay the courier",
   pay_all_delivery_note: "Includes {{count}} parcels — {{packs}} ₾",
};

export default translationEn;
